export const convDate = (date) => {
    const parts = date.split('/');
    const parts2 = parts[2].split(' ');
    const parts3 = parts2[1].split(':');
    const newDate = new Date(parts2[0], parts[1] - 1, parts[0], parts3[0], parts3[1], parts3[2]);
    return newDate.getTime();
};